import { useCallback, useMemo } from 'react';

import { validateApiResponse } from '../../../services';
import { listRoleMembers } from '../../../services/rolesService';
import { ROLE_MEMBERS_PAGE_SIZE } from '../constants/roles';
import { mapApiMemberToUi } from '../utils/mapApiMemberToUi';
import { useAsyncLoad } from './useAsyncLoad';

/** API member → a row of a member picker (builder step, Assign members): name, email, job title, UI status. */
export const mapApiRoleMemberToUi = (api) => {
  const member = mapApiMemberToUi(api);
  return {
    id: member.id,
    name: member.displayName,
    email: member.email,
    jobTitle: member.jobTitle,
    status: member.status,
    hasName: member.hasName,
  };
};

const NO_MEMBERS = Object.freeze([]);

/**
 * Members holding a role, as UI members (`mapApiMemberToUi`): `{ members, isLoading, error, reload }`.
 * `reload` reads the list again after members were assigned or removed.
 */
export const useRoleMembers = (roleId) => {
  const fetchMembers = useCallback(
    () =>
      listRoleMembers(roleId, { page_size: ROLE_MEMBERS_PAGE_SIZE }).then((res) =>
        validateApiResponse(res, 'Could not load the members').body.items.map(mapApiMemberToUi),
      ),
    [roleId],
  );
  const { data, isLoading, error, reload } = useAsyncLoad(fetchMembers, NO_MEMBERS);

  return useMemo(() => ({ members: data, isLoading, error, reload }), [data, isLoading, error, reload]);
};
